{
  "validation": {
    "subjectRequired": "Aihe on pakollinen.",
    "messageRequired": "Viestikenttä ei voi olla tyhjä.",
    "messageMaxLength": "Viesti voi olla enintään 3000 merkkiä pitkä.",
    "categoryRequired": "Viestin kategoria on pakollinen."
  },
  "view": {
    "title": "Kaikki viestit",
    "description": "Pyrimme vastaamaan viesteihin mahdollisimman nopeasti, yleensä kolmen päivän kuluessa.",
    "messageTitle": "Viesti",
    "empty": "Ei viestejä",
    "hideConversation": "Piilota keskustelu",
    "showConversation": "Näytä keskustelu",
    "sendNewMessage": "Uusi viesti",
    "newBadge": "Uusi",
    "replyToMessage": "Vastaa",
    "reply": "Vastaa",
    "previous": "Kaikki viestit",
    "noTitle": "(ei otsikkoa)"
  },
  "form": {
    "replyPrefix": "VS:",
    "subject": "Aihe",
    "category": "Viestin kategoria",
    "selectCategory": "Valitse, mitä asiasi koskee",
    "noCategory": "Ei kategoriaa",
    "categoryLoadError": "Viestikategorioita ei voitu ladata. Yritä uudelleen.",
    "retry": "Yritä uudelleen",
    "message": "Viesti",
    "attachments": "Liitteet",
    "send": "Lähetä",
    "cancel": "Peruuta",
    "errorTitle": "Viestin lähettämisessä tapahtui virhe.",
    "successTitle": "Viesti lähetettiin onnistuneesti!",
    "visibleToAllParticipants": "Vastauksesi näkyy keskustelun kaikille osallistujille."
  }
}
